/**
 * Product Card Add to Cart functionality
 * Handles adding products to cart from small and large product cards
 */

class ProductCardATC {
  constructor() {
    this.init();
  }

  init() {
    // Listen for clicks on all add to cart buttons
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.product-card-atc-btn');
      if (button && !button.disabled) {
        e.preventDefault();
        e.stopPropagation();
        this.handleAddToCart(button);
      }
    });
  }

  async handleAddToCart(button) {
    const variantId = button.dataset.variantId;
    const productId = button.dataset.productId;

    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Store original button text
    const originalText = button.textContent;

    // Update button state
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      // Add to cart via Shopify AJAX API
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Success feedback
      button.textContent = 'Added!';

      // Immediately open cart drawer and refresh
      await this.openCartDrawer();

      // Reset button after delay
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);

      // Error feedback
      button.textContent = 'Error - Try Again';

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }

  async openCartDrawer() {
    try {
      // Update cart count first
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await cartResponse.json();

      const cartCountElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        if (cart.item_count > 0) {
          element.classList.add('cart-count-bubble--visible');
        }
      });

      // Fetch updated cart drawer HTML
      const response = await fetch(window.location.origin + '/?section_id=cart-drawer');
      const html = await response.text();

      // Parse the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDrawer = doc.querySelector('cart-drawer');

      if (newCartDrawer) {
        // Replace the entire cart drawer element
        const currentCartDrawer = document.querySelector('cart-drawer');
        if (currentCartDrawer && currentCartDrawer.parentNode) {
          // Store current state
          const wasActive = currentCartDrawer.classList.contains('active');

          // Replace the element
          currentCartDrawer.parentNode.replaceChild(newCartDrawer, currentCartDrawer);

          // Reopen if it was active or always open after add to cart
          setTimeout(() => {
            const updatedCartDrawer = document.querySelector('cart-drawer');
            if (updatedCartDrawer) {
              updatedCartDrawer.classList.add('animate', 'active');

              // Trigger the open method if it exists
              if (typeof updatedCartDrawer.open === 'function') {
                updatedCartDrawer.open();
              }
            }
          }, 50);
        }
      }

      // Dispatch cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));

    } catch (error) {
      console.error('Error opening cart drawer:', error);

      // Fallback: just try to open the existing drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('animate', 'active');
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardATC();
  });
} else {
  new ProductCardATC();
}
